import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getContent } from "../../services/contentService";
import ContentPageSkeleton from "./ContentPageSkeleton/ContentPageSkeleton";
import "./Contents.css";

export default function ContentDetail() {

    const { slug } = useParams();

    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {

        const loadContent = async () => {

            try {

                setLoading(true);

                const response = await getContent(slug);

                setContent(response.data);

            } catch (error) {

                console.error("Failed to load content:", error);

                setError("Content not found.");

            } finally {

                setLoading(false);
            }
        };

        loadContent();

    }, [slug]);



    if (loading) {
    return <ContentPageSkeleton />;
}

    if (error || !content) {
        return (
            <div className="content-detail">
                <h2>Content not found</h2>
            </div>
        );
    }

      window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    return (
        <article className="content-detail">

            <div className="content-detail__container">

                  {content.title && (
                    <div className="content-detail__title-image">

                        <img
                            src={content.image}
                            alt={content.title}
                        />

                    </div>
                )}

                <h1 className="content-detail__title">
                    {content.title}
                </h1>

              

              

                <div
                    className="content-detail__content"
                    dangerouslySetInnerHTML={{
                        __html: content.content
                    }}
                />

            </div>

        </article>
    );
}